<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="main">
				<div class="navbar">
					<img @dragstart.prevent src="@/assets/topLeftImg.png" alt="" class="logo" @click="toTopImg(0)" />
					<div class="lang-switch">
						<span @click="switchLocale('zh-CN')" :class="{ active: locale === 'zh-CN' }">CN</span>
						<span class="lang-divider">|</span>
						<span @click="switchLocale('en-US')" :class="{ active: locale === 'en-US' }">EN</span>
					</div>
					<img @dragstart.prevent src="@/assets/002.png" alt="" class="search" />
					<img @dragstart.prevent src="@/assets/003.png" alt="" class="menu" @click="isMenuShow = true" />
				</div>
				<div class="navbar-placeholder"></div>
				<div class="banner" style="width: 100vw; height: 53.333333vw" v-if="isHomePage">
					<el-carousel trigger="click" height="53.333333vw">
						<el-carousel-item v-for="(item, index) in bannerImgList" :key="index" style="height: 53.333333vw">
							<img
								@dragstart.prevent
								:src="webImg + item.bannerImg + imgCut(1000, 530, 'r')"
								alt=""
								srcset=""
								style="width: 100vw;!important; height:53.333333vw;object-fit: fill;"
							/>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div v-if="showSectionBanner">
					<div style="width: 100vw; height: 45.066666vw">
						<img
							@dragstart.prevent
							v-if="currentSectionBanner"
							:src="webImg + currentSectionBanner + imgCut(1000, 450)"
							alt=""
							style="width: 100vw; height: 45.066666vw"
						/>
					</div>
				</div>
				<router-view />
				<div class="foot">
					<div class="footOne" v-if="isHomePage">
						<div class="footOneItem" v-for="item in visibleFootMenuList" :key="item.id" @click="footClick(item)">
							<img @dragstart.prevent :src="getFootMenuImg(item)" alt="" v-if="getFootMenuImg(item)" />
							<div class="footText">{{ filterUnit(item.contentTitle) }}</div>
						</div>
					</div>
					<img @dragstart.prevent src="../../src/assets/footBanner.png" alt="" class="footTwoImg" />
					<div class="footFour">
						<div class="row-1" style="cursor: pointer">
							<a @click="copyrightClick()">{{ copyrightTitle }}</a>
							<div class="line">｜</div>
							<a @click="openContactPage()" style="cursor: pointer">{{ contactTitle }}</a>
						</div>
						<div class="row-2">{{ $t('footer.copyrightOwned') }}:{{ footerCompanyName }}</div>
						<div>
							<a v-if="beianUrl && beianCode" :href="beianUrl">{{ beianCode }}</a>
							<a v-if="gonganBeianUrl && gonganBeianCode" :href="gonganBeianUrl" style="margin-left: 10px">{{ gonganBeianCode }}</a>
						</div>
					</div>
					<div class="menu-modal" v-if="isMenuShow" @click="isMenuShow = false">
						<div class="menu-modal-content" @click.stop>
							<div class="header">
								<img @dragstart.prevent src="@/assets/home.png" alt="" class="home" @click="toTopImg(0)" />
								<div class="txt" @click="toTopImg(0)">{{ $t('nav.home') }}</div>
								<div class="close" @click="isMenuShow = false"><i class="el-icon-close"></i></div>
							</div>
							<div class="lang-switch menu-lang">
								<span @click="switchLocale('zh-CN')" :class="{ active: locale === 'zh-CN' }">CN</span>
								<span class="lang-divider">|</span>
								<span @click="switchLocale('en-US')" :class="{ active: locale === 'en-US' }">EN</span>
							</div>
							<div class="menu-list">
								<div class="yiji-item" v-for="(item, index) in navBarList" :key="index">
									<div class="content" @click="navMouseEnter(index)">
										<img @dragstart.prevent src="@/assets/004.png" alt="" class="dot" />
										<div class="title">{{ item.menuName }}</div>
										<img @dragstart.prevent src="@/assets/006.png" alt="" class="arrow-down" v-if="index == enterCount" />
										<img @dragstart.prevent src="@/assets/005.png" alt="" class="arrow-right" v-else />
									</div>
									<div class="erji-item" v-if="enterCount == index" v-for="(item1, index1) in chooseList" @click.stop="chooseClick(index1)">
										<div class="txt" v-if="!isBusinessNavItem(item)">{{ item1.menuName }}</div>
										<div class="txt" v-else>{{ item1.title }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="main">
				<div class="top1">
					<img src="../assets/topLeftImg.png" alt="" class="topLeftImg" @click="toTopImg(0)" @dragstart.prevent />
					<div class="top_right">
						<div class="top">
							<input type="text" :placeholder="$t('common.search')" v-model="search" class="search" @keydown="searchInput($event)" />
							<div class="lang-switch">
								<span @click="switchLocale('zh-CN')" :class="{ active: locale === 'zh-CN' }">CN</span>
								<span class="lang-divider">|</span>
								<span @click="switchLocale('en-US')" :class="{ active: locale === 'en-US' }">EN</span>
							</div>
						</div>
						<!-- @mouseleave="enterShow = false" -->
						<div
							class="navBar"
							:class="{ 'navBar-en': locale === 'en-US' }"
							@mouseleave="
								enterShow = false;
								enterCount = -1;
								chooseDropdownStyle = {};
							"
						>
							<div class="navBarItem" @click="navBarClick(index)" @mouseenter.stop="navMouseEnter(index)" v-for="(item, index) in navBarList" :key="item.menuId || index">
								<div class="navBarItemTitle">{{ item.menuName }}</div>
								<template v-if="!isBusinessNavItem(item)">
									<div
										class="choose"
										v-if="enterCount == index && enterShow"
										:class="{ choose1: chooseList.length == 1 }"
										:style="chooseDropdownStyle"
									>
										<div
											@click.stop="chooseClick(index1)"
											class="chooseItem"
											:class="{ chooseItem1: chooseCount == index1 }"
											v-for="(item1, index1) in chooseList"
										>
											<span>{{ item1.menuName }}</span>
										</div>
									</div>
								</template>
								<template v-else>
									<div
										class="choose index2"
										v-if="enterCount == index && enterShow"
										:class="{ choose1: chooseList.length == 1 }"
										:style="chooseDropdownStyle"
									>
										<div
											class="chooseItem-wrapper"
											v-for="(classificationItem, classificationIndex) in engineeringListClassification"
											:key="classificationIndex"
										>
											<div class="title">{{ classificationItem.title }}</div>
											<div class="list">
												<div
													@click.stop="chooseClick(index1, item1)"
													class="chooseItem"
													:class="{ chooseItem1: chooseCount == index1 }"
													v-for="(item1, index1) in classificationItem.list"
												>
													<span>{{ item1.title }}</span>
												</div>
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<div style="width: 100%; height: 5px; background: #0072c4"></div>
				<div class="banner" style="width: 100vw; height: 25.17vw" v-if="isActive('/home')">
					<el-carousel trigger="click" height="25.17vw">
						<el-carousel-item v-for="(item, index) in bannerImgList" :key="index" style="height: 25.17vw">
							<img @dragstart.prevent :src="webImg + item.bannerImg + imgCut(1920, 251, 'r')" alt="" srcset="" style="width: 100vw;!important; height:25.17vw;" />
						</el-carousel-item>
					</el-carousel>
				</div>
				<div v-if="showSectionBanner">
					<div style="width: 100vw; height: 25.17vw">
						<img
							@dragstart.prevent
							v-if="currentSectionBanner"
							:src="webImg + currentSectionBanner + imgCut(1000, 251, 'r')"
							alt=""
							style="width: 100vw; height: 25.17vw"
						/>
					</div>
				</div>
				<router-view />

				<div class="foot">
					<div class="footOne" v-if="isHomePage">
						<div class="footOneItem" v-for="item in visibleFootMenuList" :key="item.id" @click="footClick(item)">
							<img @dragstart.prevent :src="getFootMenuImg(item)" alt="" v-if="getFootMenuImg(item)" />
							<div class="footText">{{ filterUnit(item.contentTitle) }}</div>
						</div>
					</div>
					<img @dragstart.prevent src="../../src/assets/footBanner.png" alt="" class="footTwoImg" />
					<div class="footThree">
						<div class="link">{{ $t('footer.friendLinks') }}</div>
						<div style="margin-left: 40px">
							<el-select v-model="value" :placeholder="$t('footer.relatedUnits')" @change="change">
								<!-- <div v-infinite-scroll="load" style="overflow:auto;height: 100px;"> -->
								<el-option v-for="item in options" :key="item.id" :label="item.unitName" :value="item"></el-option>
								<!-- </div> -->
							</el-select>
						</div>
					</div>

					<div class="footFour">
						<div style="cursor: pointer">
							<a @click="copyrightClick()">{{ copyrightTitle }}</a>
							｜
							<a @click="openContactPage()" style="cursor: pointer">{{ contactTitle }}</a>
						</div>
						<div>{{ $t('footer.copyrightOwned') }}:{{ footerCompanyName }}</div>
						<div>
							<a v-if="beianUrl && beianCode" :href="beianUrl">{{ beianCode }}</a>
							<a v-if="gonganBeianUrl && gonganBeianCode" :href="gonganBeianUrl" style="margin-left: 10px">{{ gonganBeianCode }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { menu, bannerList, menuAll, businessList, unitList, unitBelowList, singleinfo, contactUs, contentPage, configGroup } from '../api/api';
import { buildBusinessGroups, filterCategorizedBusinessList } from '../utils/businessCategory';
import { attachNavMeta, buildCmsLocation, findNavByType, isExternalMenu as cmsIsExternalMenu, filterVisibleNavMenus, isContentHidden } from '../utils/cmsNav';

const FOOT_MENU_ID = 2142;

export default {
	name: 'mainTemplate',
	data() {
		return {
			bannerImgList: [],
			show: false,
			navBarList: [],
			count: 0,
			chooseCount: -1,
			options: [],
			optionsChildren: [],
			value: '',
			valueChildren: '',
			chooseList: [],
			unitBelowList: [],
			search: '',
			enterShow: false,
			enterCount: -1,
			isMenuShow: false,
			chooseMenuList: [[], [], [], [], [], []],
			footMenuList: [],
			engineeringList: [],
			engineeringGroups: [],
			copyrightTitle: '',
			footerCompanyName: '',
			beianCode: '',
			beianUrl: '',
			gonganBeianCode: '',
			gonganBeianUrl: '',
			chooseDropdownStyle: {}
		};
	},
	computed: {
		...mapGetters(['isMobile', 'locale']),
		engineeringListClassification() {
			return this.engineeringGroups;
		},
		contactTitle() {
			const contactNav = findNavByType(this.navBarList, 'contact');
			if (!contactNav) return '';
			const index = this.navBarList.indexOf(contactNav);
			const children = this.chooseMenuList[index] || [];
			return (children[0] && children[0].menuName) || contactNav.menuName || '';
		},
		currentSectionBanner() {
			if (this.$route.path !== '/cms') return '';
			const parentId = this.$route.query.parentId;
			if (!parentId) return '';
			const item = this.navBarList.find((m) => String(m.menuId) === String(parentId));
			return item && item.frontImg ? item.frontImg : '';
		},
		showSectionBanner() {
			return this.$route.path === '/cms' && !!this.currentSectionBanner;
		},
		isHomePage() {
			return this.$route.path === '/home';
		},
		visibleFootMenuList() {
			const locale = this.locale || (this.$i18n && this.$i18n.locale) || 'zh-CN';
			return (this.footMenuList || [])
				.filter((item) => !isContentHidden(item, locale))
				.slice(0, 4);
		}
	},
	created() {
		this.$store.commit('changeScreenWidth');
		// 监听页面尺寸
		window.addEventListener('resize', () => {
			this.$store.commit('changeScreenWidth');
			if (!this.isMobile && this.enterShow) {
				this.adjustChooseDropdownPosition();
			}
		});
		// 监听页面滚动
		window.onscroll = () => {
			// 发送滚动事件
			this.$bus.$emit('windowOnscroll');

			// 监听滚动到底部
			if (this.$global.reachBottom(0)) {
				console.log('滚动到底部了');
				this.$bus.$emit('reachBottom');
			}
		};

		if (this.$route.query.index) {
			this.count = this.$route.query.index;
		}

		this.getBannerList(); //首页轮播图
		this.getFootMenuList(); //首页底部导航
		this.getMenuAll(); //首页轮播图
		this.getUnitList(); //友情链接
		this.getUnitBelowList(); //友情链接
		this.getCopyrightTitle(); //版权声明标题
		this.getFooterCompanyName(); //页脚公司名称
		this.getBeianConfig(); //备案信息
		console.log('this.count: ', this.count);
	},

	watch: {
		$route(to, from) {
			console.log(to.query.index, 'to');
			this.count = to.query.index;
			console.log('this.count: ', this.count);
		},
		isMenuShow(val) {
			console.log('val: ', val);
			this.$global.stopPageScroll(val);
		},
		locale() {
			this.getMenuAll();
			this.getBannerList();
			this.getFootMenuList();
			this.value = '';
			this.getUnitList();
			this.getCopyrightTitle();
			this.getFooterCompanyName();
			this.getBeianConfig();
			this.$bus.$emit('localeChanged');
		}
	},
	methods: {
		switchLocale(locale) {
			if (this.locale === locale) return;
			this.$i18n.locale = locale;
			this.$store.dispatch('locale/setLocale', locale);
		},
		getCopyrightTitle() {
			singleinfo(18).then((res) => {
				this.copyrightTitle = (res.data && res.data.title) || '';
			});
		},
		getFooterCompanyName() {
			contactUs().then((res) => {
				this.footerCompanyName = (res.data && res.data.companyName) || '';
			});
		},
		getBeianConfig() {
			configGroup('website').then((res) => {
				const config = res.data || {};
				this.beianCode = config.beian_code || '';
				this.beianUrl = config.beian_url || '';
				this.gonganBeianCode = config.gongan_beian_code || '';
				this.gonganBeianUrl = config.gongan_beian_url || '';
			});
		},
		isExternalMenu(item) {
			return cmsIsExternalMenu(item);
		},
		isBusinessNavItem(item) {
			return !!(item && item.navMeta && item.navMeta.isBusiness);
		},
		navigateCms(parentMenu, subMenu, extra = {}) {
			if (!parentMenu && !extra.singleId) return;
			if (subMenu && this.isExternalMenu(subMenu)) {
				window.open((subMenu.path || '').trim(), '_blank');
				return;
			}
			this.openUrl(
				buildCmsLocation({
					parentId: parentMenu && parentMenu.menuId,
					menuId: subMenu && subMenu.menuId,
					id: extra.id,
					contentId: extra.contentId,
					search: extra.search,
					singleId: extra.singleId,
				})
			);
		},
		openContactPage() {
			const contactNav = findNavByType(this.navBarList, 'contact');
			if (!contactNav) return;
			const index = this.navBarList.indexOf(contactNav);
			const subs = this.chooseMenuList[index] || [];
			this.navigateCms(contactNav, subs[0]);
		},
		filterUnit(item) {
			return (item || '').replace(/<br>/g, '');
		},
		getFootMenuImg(item) {
			if (item && item.contentImg) {
				return this.webImg + item.contentImg + this.imgCut(270, 200);
			}
			return '';
		},
		resolveFootMenuLink(contentUrl) {
			const raw = (contentUrl || '').trim();
			if (!raw) return null;

			if (/^https?:\/\//i.test(raw)) {
				return { type: 'external', url: raw };
			}

			let path = raw.replace(/^#\/?/, '').replace(/^\//, '');
			const qIndex = path.indexOf('?');
			const pathPart = qIndex >= 0 ? path.slice(0, qIndex) : path;
			const queryString = qIndex >= 0 ? path.slice(qIndex + 1) : '';
			const routePath = '/' + pathPart.replace(/^\//, '');
			const query = {};

			if (queryString) {
				queryString.split('&').forEach((pair) => {
					const eqIndex = pair.indexOf('=');
					if (eqIndex > 0) {
						const key = decodeURIComponent(pair.slice(0, eqIndex));
						const value = decodeURIComponent(pair.slice(eqIndex + 1));
						query[key] = value;
					}
				});
			}

			return { type: 'internal', path: routePath, query };
		},
		getFootMenuList() {
			contentPage(1, 1000, FOOT_MENU_ID, '', '', '', 0, '').then((res) => {
				this.footMenuList = res.data || [];
			});
		},
		getBannerList() {
			bannerList().then((res) => {
				console.log(res, 'res');
				this.bannerImgList = res.data;
			});
		},
		//首页链接
		toTopImg(index) {
			if (index == 0) {
				this.$router.push({
					path: '/home',
					query: {
						index: index
					}
				});
			} else {
				location.href = 'http://www.hgmri.com/';
			}
			this.isMenuShow = false;
		},
		//查询所有菜单
		getMenuAll() {
			menuAll().then((res) => {
				this.navBarList = (res.data || []).map(attachNavMeta);
				this.chooseMenuList = this.navBarList.map(() => []);
				this.navBarList.forEach((item, index) => {
					if (item.navMeta && item.navMeta.isBusiness) {
						this.loadBusinessMenu(index);
					} else {
						this.getMenu(index);
					}
				});
			});
		},
		isActive(route) {
			return this.$route.path === route;
		},
		//鼠标移入
		navMouseEnter(index) {
			if (this.enterCount == index) {
				return (this.enterCount = -1);
			}
			this.enterCount = index;
			this.enterShow = true;
			console.log('this.chooseMenuList: ', this.chooseMenuList);
			this.chooseList = this.chooseMenuList[index];
			this.chooseDropdownStyle = {};
			this.$nextTick(() => {
				this.adjustChooseDropdownPosition();
			});
		},
		adjustChooseDropdownPosition() {
			if (this.isMobile || !this.enterShow) return;
			const chooseEl = this.$el.querySelector('.device-pc .navBarItem .choose');
			if (!chooseEl) return;

			const navItem = chooseEl.closest('.navBarItem');
			if (!navItem) return;

			const viewportPadding = 16;
			const viewportWidth = window.innerWidth;
			const itemRect = navItem.getBoundingClientRect();
			const dropdownWidth = chooseEl.offsetWidth;
			let left = 0;
			let right = 'auto';

			const overflowRight = itemRect.left + dropdownWidth > viewportWidth - viewportPadding;
			if (overflowRight) {
				const leftIfRightAlign = itemRect.right - dropdownWidth;
				if (leftIfRightAlign >= viewportPadding) {
					left = 'auto';
					right = 0;
				} else {
					left = viewportWidth - viewportPadding - dropdownWidth - itemRect.left;
					left = Math.max(left, viewportPadding - itemRect.left);
				}
			}

			const style = {};
			if (left === 'auto') {
				style.left = 'auto';
				style.right = typeof right === 'number' ? `${right}px` : right;
			} else {
				style.left = `${left}px`;
				style.right = 'auto';
			}

			this.chooseDropdownStyle = style;

			this.$nextTick(() => {
				const rect = chooseEl.getBoundingClientRect();
				if (rect.left < viewportPadding) {
					this.chooseDropdownStyle = {
						left: `${viewportPadding - itemRect.left}px`,
						right: 'auto'
					};
				} else if (rect.right > viewportWidth - viewportPadding) {
					this.chooseDropdownStyle = {
						left: `${viewportWidth - viewportPadding - rect.width - itemRect.left}px`,
						right: 'auto'
					};
				}
			});
		},
		//查询子菜单
		getMenu(index) {
			if (!this.navBarList[index]) return;
			menu(this.navBarList[index].menuId).then((res) => {
				const list = filterVisibleNavMenus(res.data || [], this.locale);
				this.$set(this.chooseMenuList, index, list);
			});
		},
		rebuildBusinessGroups() {
			this.engineeringGroups = buildBusinessGroups(this.engineeringList, this.locale);
		},
		loadBusinessMenu(index) {
			businessList({ status: 1 }).then((res) => {
				const list = filterCategorizedBusinessList(res.data || []);
				this.$set(this.chooseMenuList, index, list);
				this.engineeringList = list;
				this.rebuildBusinessGroups();
			});
		},

		chooseClick(index, item = {}) {
			const parentMenu = this.navBarList[this.enterCount];
			if (!parentMenu) return;

			if (this.isBusinessNavItem(parentMenu)) {
				let businessItem = this.chooseList[index];
				if (!this.isMobile && item.title) {
					businessItem = this.chooseList.find((v) => v.title === item.title) || businessItem;
				}
				this.navigateCms(parentMenu, null, { id: businessItem && businessItem.id });
			} else {
				const subMenu = this.chooseList[index];
				this.navigateCms(parentMenu, subMenu);
			}
			this.isMenuShow = false;
		},
		//查询业务领域列表
		getBusinessList(inx) {
			const businessNav = findNavByType(this.navBarList, 'business');
			if (!businessNav) return;
			const item = this.chooseMenuList[this.navBarList.indexOf(businessNav)][inx];
			this.navigateCms(businessNav, null, { id: item && item.id });
		},
		searchInput(e) {
			if (this.search && e.keyCode == 13) {
				const newsNav = findNavByType(this.navBarList, 'news');
				if (!newsNav) return;
				const newsIndex = this.navBarList.indexOf(newsNav);
				const subs = this.chooseMenuList[newsIndex] || [];
				this.navigateCms(newsNav, subs[0], { search: this.search });
			}
		},

		//导航栏
		navBarClick(index) {
			const parentMenu = this.navBarList[index];
			if (!parentMenu) return;

			if (this.isBusinessNavItem(parentMenu)) {
				this.getBusinessList(0);
				return;
			}

			const subs = this.chooseMenuList[index] || [];
			this.navigateCms(parentMenu, subs[0]);
		},

		//友情链接
		getUnitList() {
			unitList().then((res) => {
				this.options = res.data;
			});
		},
		getUnitBelowList() {
			unitBelowList().then((res) => {
				this.optionsChildren = res.data;
			});
		},
		//底部链接
		change(e) {
			this.value = e.unitName;
			this.$confirm(this.$t('common.confirmOpenLink'))
				.then((_) => {
					this.done(e.unitLink);
				})
				.catch((_) => {});
		},
		done(e) {
			location.href = e;
		},
		//底部链接
		change1(e) {
			this.valueChildren = e.belowName;
			console.log(111111);
			this.$confirm(this.$t('common.confirmOpenLink'))
				.then((_) => {
					this.done(e.belowLink);
				})
				.catch((_) => {});
		},
		footClick(item) {
			const link = this.resolveFootMenuLink(item && item.contentUrl);
			if (!link) return;

			if (link.type === 'external') {
				window.open(link.url, '_blank');
				return;
			}

			this.openUrl({
				path: link.path,
				query: link.query
			});
		},
		copyrightClick() {
			this.openUrl(
				buildCmsLocation({
					singleId: 18,
				})
			);
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.device-mobile {
	.main {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100vw;
		min-height: 100vh;
		background: #ffffff;

		.navbar {
			position: fixed;
			top: 0;
			z-index: 99;
			display: flex;
			align-items: center;
			width: 100%;
			height: 1.333333rem;
			background: #ffffff;

			.logo {
				margin-left: 0.266667rem;
				margin-right: auto;
				width: 5.573333rem;
				height: 0.586667rem;
			}

			.search {
				width: 0.493333rem;
				height: 0.493333rem;
			}

			.menu {
				margin-left: 0.706667rem;
				margin-right: 0.453333rem;
				width: 0.453333rem;
				height: 0.426667rem;
			}
		}

		.navbar-placeholder {
			width: 100%;
			height: 1.333333rem;
		}

		.foot {
			margin-top: auto;

			.footOne {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-bottom: 0.613333rem;

				.footOneItem {
					margin-bottom: 0.266667rem;
					width: 9.466667rem;
					height: 3.2rem;
					position: relative;
					display: flex;
					justify-content: center;
					align-items: center;
					overflow: hidden;

					img {
						width: 100%;
						object-fit: cover;
					}

					.footText {
						position: absolute;
						font-size: 0.48rem;
						font-family: Microsoft YaHei-Bold, Microsoft YaHei;
						font-weight: bold;
						color: #ffffff;
					}

					.footOneMore {
						position: absolute;
						top: 0.266667rem;
						right: 0;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 0.906667rem;
						height: 0.586667rem;
						background: #0175c2;

						a {
							font-size: 0.32rem;
							font-family: Microsoft YaHei-Regular, Microsoft YaHei;
							font-weight: 400;
							color: #ffffff;
							text-decoration: none;
						}
					}
				}
			}

			.footTwoImg {
				display: flex;
				width: 100%;
				height: 1.2rem;
			}

			.footFour {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 1.866667rem;
				background: #1e243c;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;

				div,
				a {
					font-size: 0.24rem;
					font-weight: 500;
					color: #979fbf;
					text-decoration: none;
				}

				.row-1 {
					display: flex;
					align-items: center;

					.line {
						margin: 0 0.266667rem;
					}
				}

				.row-2 {
					margin: 0.1rem 0;
				}
			}
		}

		.menu-modal {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: rgba(#000000, 0.5);
			z-index: 99;

			.menu-modal-content {
				width: 8rem;
				height: 100%;
				margin-left: auto;
				background: #ffffff;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;
				overflow-y: auto;

				.header {
					display: flex;
					align-items: center;
					width: 100%;
					height: 2.4rem;

					.home {
						width: 0.4rem;
						height: 0.4rem;
						margin-left: 0.693333rem;
						margin-right: 0.293333rem;
					}

					.txt {
						margin-right: auto;
						font-size: 0.506667rem;
						font-weight: bold;
						color: #363b4c;
					}

					.close {
						display: flex;
						margin-right: 0.533333rem;

						.el-icon-close {
							font-size: 0.706667rem;
						}
					}
				}

				.menu-list {
					width: 100%;

					.yiji-item {
						width: 100%;

						.content {
							display: flex;
							align-items: center;
							position: relative;
							width: 100%;
							height: 1.333333rem;
							background-color: #ffffff;

							.dot {
								position: absolute;
								margin-left: 0.666667rem;
								width: 0.16rem;
								height: 0.16rem;
							}

							.title {
								margin-left: 1.013333rem;
								margin-right: auto;
								font-size: 0.453333rem;
								font-weight: 500;
								color: #363b4c;
							}

							.arrow-down {
								width: 0.373333rem;
								height: 0.32rem;
								margin-right: 0.453333rem;
							}

							.arrow-right {
								width: 0.32rem;
								height: 0.373333rem;
								margin-right: 0.453333rem;
							}
						}

						.erji-item {
							display: flex;
							align-items: center;
							width: 100%;
							height: 1.333333rem;
							background-color: #f7f7f7;

							.txt {
								margin-left: 1.013333rem;
								font-size: 0.4rem;
								font-weight: 500;
								color: #363b4c;
							}
						}
					}
				}
			}
		}
	}
}

.device-pc {
	.main {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100vw;
		min-height: 100vh;
		background: #ffffff;
	}

	.topLeftImg {
		width: 522px;
		height: 54px;
		cursor: pointer;
		padding-top: 40px;
	}

	.top1 {
		width: min(96vw, 1500px);
		// height: 84px;
		display: flex;

		.top_right {
			flex: 1;

			.top {
				width: 100%;
				// height: 84px;
				display: flex;
				// align-items: center;
				padding-top: 35px;
				justify-content: flex-end;

				.search {
					width: 225px;
					height: 36px;
					background: rgba(255, 255, 255, 0.2);
					border-radius: 18px 18px 18px 18px;
					border: 1px solid #0175c2;
					box-sizing: border-box;
					margin-left: auto;
					background: url(../assets/search.png) no-repeat 20px center;
					background-size: 19px 19px;
					padding-left: 50px;
					box-sizing: border-box;
				}
			}

			.navBar {
				width: 100%;
				// height: 68px;
				// background: red;
				padding-top: 28px;
				display: flex;
				flex-wrap: nowrap;
				align-items: center;
				justify-content: flex-end;

				&.navBar-en {
					.navBarItem {
						margin-left: 18px;
						font-size: 16px;
						padding: 0 12px;
					}
				}

				.navBarItem {
					width: auto;
					height: 40px;
					flex-shrink: 0;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 18px;
					font-family: Microsoft YaHei-Bold, Microsoft YaHei;
					font-weight: bold;
					color: #333333;
					cursor: pointer;
					position: relative;
					margin-left: 50px;
					padding: 0 20px;
					box-sizing: border-box;
					white-space: nowrap;

					.navBarItemTitle {
						white-space: nowrap;
					}

					&:first-child {
						margin-left: 0px !important;
					}

					.choose1 {
						width: 100% !important;
						min-width: max-content;
					}

					.choose {
						// padding-top: 4px;
						min-width: 420px;
						max-width: calc(100vw - 32px);
						// height: 100px;
						box-sizing: border-box;
						position: absolute;
						left: 0;
						top: 40px;
						z-index: 999999;
						background: #ffffff;
						display: flex;
						flex-wrap: wrap;
						font-size: 18px;
						font-family: Microsoft YaHei-Regular, Microsoft YaHei;
						font-weight: 400;
						color: #0072c4;

						&.index2 {
							display: flex;
							flex-direction: column;
						}

						.chooseItem-wrapper {
							display: flex;
							flex-direction: column;
							.title {
								color: #333;
								font-size: 18px;
								font-family: Microsoft YaHei-Bold, Microsoft YaHei !important;
								font-weight: bold;
								padding: 10px 20px;
							}
							.list {
								flex: 1;
								display: flex;
								flex-wrap: wrap;
							}
						}

						.chooseItem {
							// margin-right: 10px;
							// margin-top: 10px;
							padding: 10px 20px;
							border-bottom: 1px dashed #e5e5e5;
							border-top: 1px dashed #e5e5e5;

							span {
								// color: aqua;
								white-space: nowrap;
							}

							span:hover {
								text-decoration: underline;
							}
						}

						.chooseItem:last-child {
							// border-bottom: 1px dashed #e5e5e5;
						}

						.chooseItem1 {
							background: #0076be;
							color: #ffffff;
						}

						.chooseItem:hover {
							// background: #0076BE;
							// color: #FFFFFF;
						}
					}
				}

				.navBarItem:hover {
					background: #0076be;
					color: #ffffff;
				}

				.navBarItem1 {
					background: #0076be;
					color: #ffffff;
				}
			}
		}
	}

	.foot {
		width: 100vw;
		// background: #FFFFFF;

		.footOne {
			width: 1200px;
			height: 290px;
			display: flex;
			align-items: center;
			margin: 0 auto;
			cursor: pointer;
			position: relative;

			.footOneMore {
				position: absolute;
				right: 30px;
				top: 60px;
				width: 43px;
				height: 28px;
				// background: #0175C2;
				background: rgba(1, 117, 194, 0.5);
				font-size: 14px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #ffffff;
				display: flex;
				justify-content: center;
				align-items: center;

				a {
					color: #ffffff;
					text-decoration: none;
				}
			}

			.footOneItem {
				position: relative;
				width: 300px;
				height: 200px;
				// background: rgba(0, 0, 0, 0.5);
				overflow: hidden;
				margin-right: 30px;
				// filter: blur(1px) grayscale(.1);
				opacity: 0.6;
				// background: rgba(255, 255, 255, .6);

				// img {
				//   transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				// }
			}

			.footOneItem:hover {
				opacity: 2;
				// background: rgba(255, 255, 255, 1);

				// background: rgba(0, 0, 0, 1);

				// transform: scaleX(20%);
				// img {
				//   transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				//   transform: scale(1.1);
				// }
			}

			img {
				width: 270px;
				height: 200px;
			}

			.footText {
				font-size: 20px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #ffffff;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}

		.footTwoImg {
			width: 100vw;
			height: 140px;
		}

		.footThree {
			width: 1300px;
			height: 64px;
			display: flex;
			align-items: center;
			// justify-content: center;
			margin: 0 auto;

			.link {
				font-size: 18px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #004ea1;
			}
		}

		.footFour {
			width: 100vw;
			height: 179px;
			background: #0076be;
			font-size: 14px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #ffffff;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			line-height: 30px;

			a {
				color: #ffffff;
				text-decoration: none;
			}
		}
	}

	.banner {
		// @media screen and (min-width: 960px) and (max-width: 1200px) {
		//   zoom: .643;
		// }
	}

	.el-carousel__container {
		height: 25.17vw !important;
		height: 5.333333rem;
	}
}

.lang-switch {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #666;
	cursor: pointer;
	user-select: none;

	span {
		padding: 0 4px;

		&.active {
			color: #0072c4;
			font-weight: bold;
		}
	}

	.lang-divider {
		color: #ccc;
		padding: 0 2px;
	}
}

.device-mobile {
	.navbar .lang-switch {
		margin-right: 0.4rem;
		font-size: 0.32rem;
	}

	.menu-lang {
		padding: 0.266667rem 0.4rem;
		border-bottom: 1px solid #eee;
	}
}

.device-pc {
	.top .lang-switch {
		margin-left: 16px;
		flex-shrink: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue